import { Box, List, ListItem, ListItemText, Paper, Stack, Typography, Collapse, IconButton } from '@mui/material';
import React, { useState } from 'react';
import PushPinIcon from '@mui/icons-material/PushPin';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useSelector } from 'react-redux';
import {notation_custoquestion_all} from '../../../../bdd/bddSTUB.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapSurvey = ({ survey, match }) => {
  const { timer, period, isPin, displayDate, creation } = survey;

  // Gestion de l'état d'expansion pour chaque choix
  const [expandedChoice, setExpandedChoice] = useState(null);

  const handleToggle = (choiceIndex) => {
    setExpandedChoice(expandedChoice === choiceIndex ? null : choiceIndex);
  };

    return (
        <div>
        {/*<img src={undefined} width="60px"/>*/}
        {/*<Box>
            <Typography>Sondage</Typography>
            <Typography gutterBottom>
                {survey.question}
            </Typography>
            {survey.choices.map((choice, choiceIndex) => (
                <Stack key={`${choice.label}-${choiceIndex}`} variant="subtitle1" gutterBottom>
                {choice.entries.length === 1
                    ? choice.entries[0].name
                    : `${choice.label}: ${choice.entries.length} choix`}
                </Stack>
            ))}
        </Box>*/}
        {/*(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(period, timer/60, match.discipline)}</Typography>*/}

     
      <Box>
        <Paper
          sx={{
            padding: 2,
            marginBottom: 2,
            backgroundColor: '#f9f9f9',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '15px',
          }}
        >
          {/* Titre du sondage */}
          {match.idMatch && (
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
              Sondage
            </Typography>
          )}

          {/* Question du sondage */}
          <Typography variant="subtitle1" gutterBottom sx={{ fontStyle: 'italic', color: '#555' }}>
            {survey.question}
          </Typography>

          {/* Liste des choix du sondage */}
          <List sx={{ padding: 0 }}>
            {survey.choices.map((choice, choiceIndex) => (
              <div key={`${choice.label}-${choiceIndex}`}>
                <ListItem
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px',
                    marginBottom: '0',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    border: `1px solid #ccc`,
                    cursor: 'pointer'
                  }}
                  onClick={() => handleToggle(choiceIndex)}
                >
                  <ListItemText
                    primary={choice.entries.length === 1 ? choice.entries[0].name : `${choice.label}`}
                    sx={{ color:  '#333' }}
                  />
                  <IconButton>
                    {expandedChoice === choiceIndex ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </ListItem>

                {/* Affichage des choix lorsque l'utilisateur clique */}
                <Collapse in={expandedChoice === choiceIndex} timeout="auto" unmountOnExit>
                  <Box sx={{ padding: '10px 20px', backgroundColor: '#f5f5f5', borderRadius: '0 0 12px 12px' }}>
                    {choice.entries.map((entry) => (
                      <Typography key={entry.id} variant="body2" sx={{ marginBottom: '5px', borderBottom: '1px dashed #00000021'}}>
                        {entry.name}
                      </Typography>
                    ))}
                  </Box>
                </Collapse>
              </div>
            ))}
          </List>
        </Paper>
      </Box>

      {/* Match minute if applicable */}
      {match.idMatch && (timer !== 0 || period !== 0) && (
        <Typography>Minute : {getVisualTimer(period, timer / 60, match.discipline)}</Typography>
      )}

      {/* Display if pinned */}
      {isPin && (
        <Typography variant="body1" color="primary" sx={{ marginTop: 1 }}>
          <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
          Ce sondage est épinglé
        </Typography>
      )}

      {/* Display Date */}
      {displayDate ? (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(displayDate).toLocaleDateString()} à {new Date(displayDate).toLocaleTimeString()}
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(creation).toLocaleDateString()} à {new Date(creation).toLocaleTimeString()}
        </Typography>
      )}
    </div>
  );
}

export default RecapSurvey